import { useMemo, useState } from "react";
import { PRODUCTS, CATEGORIES } from "../data/products";
import ProductCard from "./ProductCard";
import ProductQuickView from "./ProductQuickView";

const matchesFilter = (p, f) => {
  if (f === "all") return true;
  if (f === "women" || f === "men") return p.audience.includes(f);
  const map = {
    dresses: ["Dresses"],
    shirts: ["Shirts"],
    tops: ["Tops"],
    pants: ["Pants"],
    sets: ["Sets"],
    shorts: ["Shorts"],
  };
  const cats = map[f] || [];
  return cats.includes(p.category);
};

const Collection = () => {
  const [filter, setFilter] = useState("all");
  const [active, setActive] = useState(null);
  const [open, setOpen] = useState(false);

  const filtered = useMemo(
    () => PRODUCTS.filter((p) => matchesFilter(p, filter)),
    [filter]
  );

  const handleOpen = (p) => {
    setActive(p);
    setOpen(true);
  };

  return (
    <section
      id="collection"
      data-testid="collection"
      className="py-20 md:py-28 bg-[hsl(var(--background))]"
    >
      <div className="container-tjb">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between mb-8">
          <div>
            <p className="eyebrow">Shop Our Collection</p>
            <h2 className="h-section mt-3">The Triple J Edit</h2>
          </div>
          <p className="text-sm text-[hsl(var(--muted-foreground))] max-w-sm">
            Linen-focused outfits with selected cotton, silk, and linen-cotton
            pieces. Sizes and final colors confirmed via WhatsApp.
          </p>
        </div>

        {/* Filters */}
        <div
          className="flex gap-2 overflow-x-auto pb-2 mb-8 -mx-5 px-5 md:mx-0 md:px-0 md:flex-wrap md:overflow-visible"
          data-testid="collection-filters"
        >
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              data-testid={`filter-${c.id}`}
              onClick={() => setFilter(c.id)}
              className={`chip whitespace-nowrap ${
                filter === c.id ? "chip-active" : ""
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <p className="text-center py-16 text-[hsl(var(--muted-foreground))]">
            No products in this category yet.
          </p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {filtered.map((p, i) => (
              <ProductCard key={p.id} product={p} onOpen={handleOpen} idx={i} />
            ))}
          </div>
        )}
      </div>

      <ProductQuickView product={active} open={open} onOpenChange={setOpen} />
    </section>
  );
};

export default Collection;
